module.exports = {
  "zones": {
    "Europe/Kaliningrad": ["z", {
      "wallclock": 1414288800000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 1414278000000,
      "save": 0
    }, {
      "wallclock": 1301191200000,
      "format": "+03",
      "abbrev": "+03",
      "offset": 10800000,
      "posix": 1301184000000,
      "save": 0
    }, {
      "wallclock": 606880800000,
      "format": "EE%sT",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 606870000000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": -757382400000,
      "format": "MSK/MSD",
      "abbrev": "MSK",
      "offset": 10800000,
      "posix": -757389600000,
      "save": 0,
      "rules": "Russia"
    }, {
      "wallclock": -788918400000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 7200000,
      "posix": -788922000000,
      "save": 0,
      "rules": "Poland"
    }, {
      "wallclock": -2422051200000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -2422056120000,
      "save": 0,
      "rules": "C-Eur"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 4920000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Russia": [{
      "from": 1985,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2010,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1981,
      "to": 1983,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 1,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 2,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "+05",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 8,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 4,
      "day": [7, 31],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 6,
      "day": [7, 1],
      "time": 0,
      "clock": "posix",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 7,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MSK",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 4,
      "day": [7, 31],
      "time": 1320,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 8,
      "day": [7, 16],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 6,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 11,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MMT",
      "saved": 0
    }],
    "Poland": [{
      "from": 1961,
      "to": 1964,
      "month": 4,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1962,
      "to": 1964,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1959,
      "to": 1961,
      "month": 9,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1960,
      "to": 1960,
      "month": 3,
      "day": [7, 3],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1959,
      "to": 1959,
      "month": 4,
      "day": [7, 31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1958,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1958,
      "to": 1958,
      "month": 2,
      "day": [7, 30],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1957,
      "month": 5,
      "day": [7, 2],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1949,
      "month": 9,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1949,
      "month": 3,
      "day": [7, 10],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 3,
      "day": [7, 18],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1947,
      "month": 4,
      "day": [7, 4],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 3,
      "day": [7, 14],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 9,
      "day": [7, 7],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 3,
      "day": [7, 29],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1944,
      "to": 1944,
      "month": 3,
      "day": [7, 3],
      "time": 120,
      "clock": "standard",
      "save": 60,
      "letter": "S"
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 4],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1919,
      "month": 8,
      "day": [7, 16],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 3,
      "day": [7, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }],
    "C-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "standard",
      "save": 60,
      "letter": "S"
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1945,
      "month": 3,
      "day": [1, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 16],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 4],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 3,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 3,
      "day": [1, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 8,
      "day": [1, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1916,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};